<template>
  <div class="modal-mask" @mousedown.self.stop="closeModal">
    <div class="modal" @click.stop>
      <div class="modal__head">
        <h3 class="modal__title">Добавить образование</h3>
        <div class="close" @click.stop="closeModal">
          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L16 16" stroke="currentColor" stroke-width="2"/>
            <path d="M1 16L16 1" stroke="currentColor" stroke-width="2"/>
          </svg>
        </div>
      </div>
      <div class="modal__body">
        <div class="modal__row">
          <AppSelect title="Вид образования"
                     placeholder="Укажите вид образования"
                     :value="newEducation.type"
                     :options="educationTypesList"
                     @value-changed="setType"
          />
        </div>
        <div class="modal__row">
          <AppInput title="Учебное заведение"
                    :value="newEducation.organization"
                    :valid="{}"
                    @value-changed="setOrganization"
          />
        </div>
        <div class="modal__row">
          <div class="page__item">
            <AppInputDate title="Дата начала обучения"
                          :value="newEducation.start_at"
                          type="single"
                          :valid="{}"
                          width="184px"
                          @value-changed="setDateStart"
            />
          </div>
          <div class="page__item">
            <AppInputDate title="Дата окончания"
                          :value="newEducation.end_at"
                          type="single"
                          :valid="{}"
                          width="184px"
                          @value-changed="setDateEnd"
            />
          </div>
        </div>
        <div class="modal__row">
          <AppSelect title="Специальность"
                     placeholder="Укажите специальность"
                     :value="newEducation.speciality"
                     :options="educationSpecialityList"
                     @value-changed="setSpeciality"
          />
        </div>
        <div class="modal__row">
          <AppSelect title="Документ"
                     placeholder="Укажите документ"
                     :value="newEducation.document"
                     :options="educationDocumentList"
                     @value-changed="setDocument"
          />
        </div>
        <div class="modal__row mb-40">
          <AppInputDate title="Дата выдачи"
                        :value="newEducation.date_at"
                        type="single"
                        :valid="{}"
                        @value-changed="setDateAt"
          />
        </div>
        <div class="modal__button-wrap">
          <div class="modal__button">
            <AppButton title="Сохранить" type="main" @click.native="createEducation"/>
          </div>
          <div class="modal__button">
            <AppButton title="Отмена" type="alt" @click.native="closeModal"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppButton from '../button/AppButton.vue'
import AppInput from '../input/AppInput'
import AppSelect from '../input/AppSelect'
import AppInputDate from '@/components/page/input/AppInputDate'
import { mapGetters } from 'vuex'

export default {
  name: 'user-education-create-modal',
  components: {
    AppInputDate,
    AppSelect,
    AppInput,
    AppButton
  },
  props: {
    newEducation: Object
  },
  computed: {
    ...mapGetters({
      educationTypesList: '[dictionaries] usersEducationTypesList',
      educationSpecialityList: '[dictionaries] usersEducationSpecialityList',
      educationDocumentList: '[dictionaries] usersEducationDocumentList'
    })
  },
  methods: {
    loadOptions () {
      this.$store.dispatch('[dictionaries] getEducationTypes')
      this.$store.dispatch('[dictionaries] getSpecialities')
      this.$store.dispatch('[dictionaries] getEducationDocumentList')
    },
    createEducation () {
      this.$store.dispatch('createUserEducation')
    },
    closeModal () {
      this.$emit('close-modal')
    },
    setType (type) {
      this.$store.dispatch('setUserNewEducationType', type)
    },
    setOrganization (organization) {
      this.$store.dispatch('setUserNewEducationOrganization', organization)
    },
    setDateStart (date) {
      this.$store.dispatch('setUserNewEducationDateStart', date)
    },
    setDateEnd (date) {
      this.$store.dispatch('setUserNewEducationDateEnd', date)
    },
    setSpeciality (speciality) {
      this.$store.dispatch('setUserNewEducationSpeciality', speciality)
    },
    setDocument (document) {
      this.$store.dispatch('setUserNewEducationDocument', document)
    },
    setDateAt (date) {
      this.$store.dispatch('setUserNewEducationDateAt', date)
    }
  },
  mounted () {
    this.loadOptions()
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/_vars';
@import '../../../assets/css/system/_mixins';

.modal-mask {
  align-items: flex-start;
  padding-top: 20px;
  padding-bottom: 100px;
  overflow: auto;
}

.modal {
  max-width: 500px;

  &__row {
    display: flex;
    flex-flow: row nowrap;
    width: 100%;
    margin-bottom: 20px;
  }

  &__text {
    text-align: center;
    color: $font_color_second;
    margin-bottom: 20px;
  }

  &__button-wrap {
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
  }

  &__button {
    margin-right: 16px;
    margin-bottom: 10px;

    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
